import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'lib-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {


  @Input()
  username: string;

  @Input()
  loggedIn: boolean;

  @Input()
  userToolTip: string;

  @Input()
  homepage: string;

  @Output('onLogout')
  onLogout: EventEmitter<void>;

  constructor() {
    this.onLogout = new EventEmitter();
  }

  ngOnInit(): void {
  }

  logout() {
    this.onLogout.emit();
  }

}
